import { useParams } from 'react-router-dom';
import { useGetSingleAssetsQuery } from '@customer/store/apis/assetsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { VdsCard } from '@volt/volt-extended-components-react';
import { NoResults } from '@dmc/ui';

export const SingleAssetInstallerConfig = () => {
  const { assetId } = useParams();

  const { currentData: asset } = useGetSingleAssetsQuery(assetId ?? skipToken);

  const json = useMemo(() => {
    if (asset?.inst) {
      return JSON.stringify(asset.inst, null, 2);
    }

    return null;
  }, [asset?.inst]);

  return (
    <div>
      <VdsCard>
        {json ? (
          <pre>{json}</pre>
        ) : (
          // Deliberately no translation here as it's a preview thing
          <NoResults description={'No installer configuration reported'} height={300} />
        )}
      </VdsCard>
    </div>
  );
};

export default SingleAssetInstallerConfig;
